import React, { useEffect, useState } from "react";
import HttpClient from "../../utils/HttpClient";
import toast from "react-hot-toast";
import DataTable from "react-data-table-component";
import CustomLoader from "../../CustomComponents/loader/CustomLoader";
import HttpClientXml from "../../utils/HttpClientXml";
import HomeServices from "../../Services/HomeServices";
import "./Pages.css";
import Swal from "sweetalert2";
import { Form, Link, useLocation, useNavigate } from "react-router-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import BackPageBtn from "../BackButton/BackPageBtn";
import moment from "moment";

const AssignedServices = () => {
  const location = useLocation();
  const user = location.state?.user;
  console.log("Amit User", user);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [assignServicesLoading, setAssignServicesLoading] = useState(false);

  const [allData, setAllData] = useState();
  const [editId, setEditId] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [documentTypes, setDocumentTypes] = useState([]);
  const [selectedDocumentType, setSelectedDocumentType] = useState();
  const [amount, setAmount] = useState("");

  const [assignServiceFormDisplay, setAssignServiceFormDisplay] =
    useState(true);
  const [uploadDocumentFormDisplay, setUploadDocumentFormDisplay] =
    useState(false);

  const initValue = {
    serviceName: "",
    // documentation: selectedTypes
  };
  const [formValue, setFormValue] = useState(initValue);

  const fetchDocumentTypes = async (items) => {
    console.log("POI40", items);

    try {
      // Call your API function
      const response = await HomeServices.getAllDocumentTypes();
      console.log("WED62", response.data, items);
      if (response && response?.status) {
        setDocumentTypes(
          response.data.filter((doc) => items.includes(doc._id)),
        );
      }
    } catch (error) {
      console.error("Error fetching warehouse data:", error);
    }
  };

  const [allServices, setAllServices] = useState([]);
  const fetchServices = async () => {
    try {
      // Call your API function
      const response = await HomeServices.getAllServices();
      console.log("WEX53", response.data);
      if (response && response?.status) {
        setAllServices(response.data);
      }
    } catch (error) {
      console.error("Error fetching warehouse data:", error);
    }
  };

  console.log("jhsgdfjhakd", editId);

  const [isEdit, setIsEdit] = useState(true);
  const [editData, setEditData] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValue((prev) => ({ ...prev, [name]: value }));
  };

  const [assignService, setAssignService] = useState("");

  // submit
  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   // console.log("alldasdasdd", formValue);
  //   // return
  //   const { title, description } = formValue;
  //   const isValid = title.trim() !== "" && description.trim() !== "";

  //   if (isValid) {
  //     if (formValue?.image1 === "" || formValue?.image2 === "") {
  //       return toast.error("Please Upload Images");
  //     } else {
  //       const res = await HomeServices.addBlog(formValue);
  //       // console.log("resCat", res)
  //       if (res && res?.status) {
  //         toast.success("Blog Added Successfully");
  //         fetchData();

  //         // navigate('/manage-category');
  //         setIsLoading(false);
  //         console.log("formValue21456", formValue);
  //       } else {
  //         toast.error(res?.message || "Something Wrong");
  //         setIsLoading(false);
  //       }
  //     }
  //   } else {
  //     toast.error("Please Fill All The Inputs, Including the Image.");
  //   }
  // };

  const [serviceForDocumentUpload, setServiceForDocumentUpload] = useState({
    serviceId: "",
    assignedServiceId: "",
  });
  const handleUploadDocumentForm = (e, item) => {
    e.preventDefault();
    // console.log("TRE113", item);
    // setServiceForDocumentUpload({
    //   serviceId: item?.ServiceData?._id,
    //   assignedServiceId: item._id,
    // });
    // fetchDocumentTypes(item?.ServiceData?.documentation);
    // setAssignServiceFormDisplay(false);
    // setUploadDocumentFormDisplay(true);

    console.log("Amit view documents", item);
    navigate("/documents", {
      state: {
        userId: item?.userId,
        serviceId: item?.serviceId,
      },
    });
  };

  const handleServiceNotes = (e, id, name) => {
    e.preventDefault();
    console.log("HGF124", name);
    navigate("/service-notes", {
      state: { user: user, assignedService: id, assignedServiceName: name },
    });
  };

  useEffect(() => {
    setUploadedFile("");
  }, [serviceForDocumentUpload, selectedDocumentType]);

  const updateServiceStatus = async (e, id) => {
    e.preventDefault();
    console.log("UGC134", e.target.value, id);
    const formData = {
      assignServiceId: id,
      assignStatus: e.target.value,
    };

    await HomeServices.updateAssignedServiceStatus(formData)
      .then((res) => {
        if (res && res?.status) {
          toast.success("Status updated successfully");
          fetchData();
        } else {
          toast.error(res?.message || "Failed to Update");
        }
      })
      .catch((err) => {
        toast.error(err?.message || "An error occurred");
        console.error("err", err);
      });
  };

  const serviceStatus = [
    "Consultation Only",
    "Start",
    "Working",
    "Ongoing",
    "Completed",
  ];

  const columns = [
    { name: "SL No.", selector: "sln", sortable: true, center: true },
    {
      name: "Service Number",
      selector: "assignNo",
      wrap: true,
      width: "180px",
    },
    {
      name: "Assign Date",
      selector: "assignDate",
      wrap: true,
      width: "180px",
      center: true,
    },
    {
      name: "Name",
      selector: "serviceName",
      wrap: true,
      width: "180px",
      center: true,
    },
    // {
    //   name: "Total Amount",
    //   selector: "amount",
    //   wrap: true,
    //   width: "180px",
    //   center: true,
    // },
    // {
    //   name: "Paid Amount",
    //   selector: "paidAmount",
    //   wrap: true,
    //   width: "180px",
    //   center: true,
    // },
    {
      name: "Status",
      selector: "workStatus",
      wrap: true,
      width: "180px",
      center: true,
    },
    {
      name: "Document",
      selector: "action",
      wrap: true,
      width: "180px",
      center: true,
    },
    {
      name: "Note",
      selector: "note",
      wrap: true,
      width: "180px",
      center: true,
    },
    // {
    //   name: "Payment",
    //   selector: "payment",
    //   wrap: true,
    //   width: "180px",
    //   center: true,
    // },
  ];

  const [previewUploadedDocumentFile, setPreviewUploadedDocumentFile] =
    useState("");
  const fetchData = async () => {
    try {
      // Call your API function
      const response = await HomeServices.getAssignedServicesByUser({
        userId: user?.userId,
      });
      console.log("amit response", response.data);
      if (response && response?.status) {
        if (selectedDocumentType) {
          const serviceId = serviceForDocumentUpload.assignedServiceId;
          const serviceDataId = serviceForDocumentUpload.serviceId;
          const documentId = selectedDocumentType;

          const uploadedData = response?.data
            .find(
              (item) =>
                item._id === serviceId &&
                item.ServiceData._id === serviceDataId,
            )
            ?.ServiceData?.documents.find(
              (doc) => doc._id === documentId,
            )?.uploadedData;
          setUploadedFile(uploadedData[0]?.file);
          console.log("UPD153", uploadedData[0]?.file);
        }
        let arr = response?.data?.reverse()?.map((ele, index) => {
          return {
            sln: index + 1,
            assignNo: ele?.assignNo || "N/A",
            assignDate: moment(ele?.ServiceData?.createdAt).format(
              "DD-MMM-YYYY",
            ),
            amount: ele?.amount,
            paidAmount: ele?.totalPaidAmount,
            serviceName: ele?.ServiceData?.serviceName,
            documentsCount: ele?.ServiceData?.documentation?.length,
            workStatus: (
              <>
                <div>
                  <select
                    className="form-control"
                    value={ele?.assignStatus}
                    onChange={(e) => updateServiceStatus(e, ele._id)}
                  >
                    <option value="">{ele?.assignStatus || "Choose..."}</option>
                    {serviceStatus
                      .filter((item) => item !== ele?.assignStatus)
                      .map((item, i) => {
                        return (
                          <>
                            <option value={item} key={i}>
                              {item}
                            </option>
                          </>
                        );
                      })}
                  </select>
                </div>
              </>
            ),
            // action: (
            //   <>
            //     <div>
            //       <button
            //         className="btn btn-success btn-sm"
            //         onClick={(e) => handleUploadDocumentForm(e, ele)}
            //       >
            //         View/Upload ({ele?.ServiceData?.documentation?.length})
            //       </button>
            //     </div>
            //   </>
            // ),
            action: (
              <>
                <div>
                  <button
                    style={{
                      width: "100%",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                    className="btn btn-success btn-sm "
                    onClick={(e) => handleUploadDocumentForm(e, ele)}
                  >
                    View/Upload ({ele?.ServiceData?.documentation?.length})
                  </button>
                </div>
              </>
            ),
            note: (
              <>
                <div>
                  <button
                    className="btn btn-warning btn-sm"
                    onClick={(e) =>
                      handleServiceNotes(
                        e,
                        ele._id,
                        ele?.ServiceData?.serviceName,
                      )
                    }
                  >
                    View/Add Note ({ele?.serviceNotes?.length})
                  </button>
                </div>
              </>
            ),
            payment: (
              <>
                <div>
                  <button
                    className="btn btn-warning btn-sm"
                    onClick={(e) =>
                      navigate("/manage-payments-for-services", {
                        state: {
                          user: user,
                          serviceId: ele?._id,
                        },
                      })
                    }
                  >
                    {/* View/Add Note ({ele?.serviceNotes?.length}) */}
                    Payment/History
                  </button>
                </div>
              </>
            ),
          };
        });
        setAllData(arr);
      }
    } catch (error) {
      console.error("Error fetching warehouse data:", error);
    }
  };

  useEffect(() => {
    // fetchDocumentTypes()
    fetchServices();
    fetchData();
  }, []);

  // click on edit
  const handleEdit = (e, ele) => {
    e.preventDefault();
    console.log("FTY164", ele);

    window.scrollTo(0, 0);
    // setSelectedTypes(ele.documentation)
    setEditMode(true);
    setEditId(ele?._id);
    setFormValue({
      serviceName: ele.serviceName,
      documentation: ele.documentation,
    });
  };

  // const handleDelete = async (id) => {
  //   console.log("deleteblogid", id);
  //   Swal.fire({
  //     title: "Are you sure?",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonColor: "#3085d6",
  //     cancelButtonColor: "#d33",
  //     confirmButtonText: "Yes, delete it!",
  //   }).then((result) => {
  //     console.log("result", result);
  //     if (result?.isConfirmed) {
  //       HomeServices.deleteService(id)
  //         .then((res) => {
  //           if (res && res.status) {
  //             toast.success("Deleted Successfully");
  //             fetchData();
  //           } else {
  //             toast.error(res?.message);
  //           }
  //         })
  //         .catch((err) => {
  //           console.error("Error deleting document:", err);
  //         });
  //     } else {
  //       console.log("Deletion canceled");
  //     }
  //   });
  // };

  // const handleCheckboxChange = (event) => {
  //   const { value, checked } = event.target;
  //   setSelectedTypes((prev) =>
  //     checked ? [...prev, value] : prev.filter((type) => type !== value)
  //   );
  // };

  const handleAssign = async (e) => {
    e.preventDefault();
    if (!assignService || !amount)
      return toast.error("Choose the Service Name & Amount to assign");
    const formData = {
      userId: user?.userId,
      serviceId: assignService,
      amount: Number(amount),
    };
    console.log("VFE208", formData);
    // return
    setAssignServicesLoading(true);
    await HomeServices.assignService(formData)
      .then((res) => {
        if (res && res?.status) {
          toast.success("Assigned successfully");
          // fetchLiveData(formData?.userId);
          fetchData();
          setAssignServicesLoading(false);
        } else {
          toast.error(res?.message || "Failed to Assign");
          setAssignServicesLoading(false);
        }
      })
      .catch((err) => {
        toast.error(err?.message || "An error occurred");
        console.error("err", err);
        setAssignServicesLoading(false);
      });
  };

  // useEffect(() => {
  //   setFormValue({ ...formValue, documentation: selectedTypes })
  // }, [selectedTypes])

  //////////////////File Upload//////////////////////
  const [loadingFile, setLoadingFile] = useState("");
  const [uploadedFile, setUploadedFile] = useState("");
  // Update file name when file is selected
  const handleFileChange = async (e) => {
    // const fileName = event.target.files[0]?.name || '';
    setLoadingFile("Uploading document. Please wait...");

    /////Uploading Single Image////
    const formData = new FormData();
    formData.append("image", e.target.files[0]);

    try {
      const res = await HttpClientXml.fileUplode(
        "image-upload",
        "POST",
        formData,
      );

      if (res && res.status) {
        setUploadedFile(res?.data?.url);
        ////Upload Document///////
        const formData = {
          // userId: user?._id,
          userId: user?.userId,
          assignedServiceId: serviceForDocumentUpload.assignedServiceId,
          serviceId: serviceForDocumentUpload.serviceId,
          documentId: selectedDocumentType,
          file: res?.data?.url,
          // uploadedBy: "admin"
        };

        // console.log("WFGN290",formData);
        // return

        try {
          const res = await HttpClientXml.requestRawData(
            "upload-documents",
            formData,
            "POST",
          );
          console.log("response after upload", res);
          // console.log("TRE333", res);
          // return
          if (res && res.status) {
            toast.success(res?.message);
            fetchData();
          } else {
            toast.error(res?.message);
          }
        } catch (error) {
          console.error("Error uploading document:", error);
          toast.error("Document upload failed.");
        }
        ///////////////////////
      } else {
        toast.error(res?.message || "Image upload failed");
        console.error("Error uploading image:", res?.message);
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      // toast.error("Image upload failed");
    }
    //////////////////////////////

    setLoadingFile("");
  };

  // Submit just file names
  const handleDocumentUpload = async (e) => {
    e.preventDefault();

    const formData = {
      userId: user?._id,
      assignServicesId: serviceForDocumentUpload.id,
      documentationId: selectedDocumentType,
      file: uploadedFile,
      uploadedBy: "admin",
    };
    console.log("QSC344", formData);

    try {
      const res = await HttpClientXml.requestRawData(
        "upload-documents",
        formData,
        "POST",
      );
      console.log("TRE333", res);
      // return
      if (res && res.status) {
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      toast.error("Image upload failed");
    }
  };
  ///////////////////////////////////////////////////

  useEffect(() => {
    // selectedDocumentType && files.length === 0 && setFiles(['']);
    fetchData();
  }, [selectedDocumentType]);

  const handleReuploadDocument = () => {
    setUploadedFile("");
  };

  return (
    <>
      <CustomLoader loading={isLoading} />
      <div className="d-flex justify-content-end mt-2">
        <div className="form-header">
          <BackPageBtn backLink="/users" />
        </div>
      </div>
      {/* {assignServiceFormDisplay && (
        <div className="d-flex justify-content-end _mt-2">
          <div className="form-header">
            <section className="piechartsBox_area">
              <form>
                <div>
                  <h1
                    style={{
                      color: "#ff9c00",
                      fontSize: "25px",
                      fontWeight: "600",
                      marginBottom: "10px",
                    }}
                  >
                    Assign Service
                  </h1>
                </div>
                <div className="row mt-4">
                  <div className="col">
                    <label htmlFor="formGroupExampleInput">Service</label>
                    <select
                      className="form-control"
                      value={assignService}
                      onChange={(e) => setAssignService(e.target.value)}
                    >
                      <option value="">---All---</option>
                      {allServices.map((item, key) => (
                        <option key={key} value={item._id}>
                          {item.serviceName}
                        </option>
                      ))}
                    </select>
                    <label
                      style={{ marginTop: "20px" }}
                      htmlFor="formGroupExampleInput"
                    >
                      Amount
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Amount"
                      name="amount"
                      value={amount}
                      onChange={(e) => {
                        if (/^\d*$/.test(e.target.value)) {
                          // setFormDataForEdit((prev) => ({
                          //   ...prev,
                          //   commissionRatePercent: Number(e.target.value),
                          // }));
                          setAmount(Number(e.target.value));
                        }
                      }}
                    />
                  </div>
                </div>

                <div class="col-12 ">
                  <button
                    disabled={assignServicesLoading}
                    type="submit"
                    onClick={(e) => handleAssign(e)}
                    class="btn btn-primaryb mt-3 addBlogBtn"
                    style={{
                      background: "linear-gradient(195deg, #FFB14C, #ff9000)",
                      color: "#fff",
                    }}
                  >
                    
                    {assignServicesLoading ? "Loading..." : "Assign"}
                  </button>
                </div>
              </form>
            </section>
          </div>
        </div>
      )} */}
      {uploadDocumentFormDisplay && (
        <div className="d-flex justify-content-end _mt-2">
          <div className="form-header">
            <section className="piechartsBox_area">
              <form>
                <div>
                  <h1
                    style={{
                      color: "#ff9c00",
                      fontSize: "25px",
                      fontWeight: "600",
                      marginBottom: "10px",
                    }}
                  >
                    {/* Upload Document for {serviceForDocumentUpload?.name} */}
                    Upload Document for {user?.userData?.name}
                  </h1>
                </div>
                <div className="row mt-4">
                  <div className="col-12">
                    <label htmlFor="formGroupExampleInput">Document Type</label>
                    <select
                      className="form-control"
                      value={selectedDocumentType}
                      onChange={(e) => {
                        setSelectedDocumentType(e.target.value);
                      }}
                    >
                      <option value="">---Select---</option>
                      {documentTypes.map((item, key) => (
                        <option key={key} value={item._id}>
                          {item.document}
                        </option>
                      ))}
                    </select>
                    {/* <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Service Name"
                      name="serviceName"
                      value={formValue?.serviceName}
                      onChange={(e) => { setFormValue({ ...formValue, serviceName: e.target.value }) }} 
                    />*/}
                  </div>
                  {selectedDocumentType && (
                    <>
                      <div className="col-12 _mt-4">
                        <div className="row">
                          <div className="col-4 _mb-3 _d-flex align-items-center">
                            <div className="mb-2">
                              {loadingFile ? (
                                loadingFile
                              ) : (
                                <>
                                  {uploadedFile && (
                                    <div>
                                      <a
                                        href={uploadedFile}
                                        data-lightbox="uploaded-image"
                                        data-title="Document File"
                                      >
                                        <img
                                          src={uploadedFile}
                                          alt="Document File"
                                          style={{
                                            maxHeight: "256px",
                                            margin: "1em 0",
                                            height: "auto",
                                            cursor: "pointer",
                                            borderRadius: "8px",
                                          }}
                                        />
                                      </a>
                                      {/* <span title="Delete"
                                    onClick={() => handleReuploadDocument()}
                                  >
                                    <i
                                      className="fa-regular fa-trash-can"
                                      style={{
                                        cursor: "pointer",
                                        marginRight: "10px",
                                        padding: "5px",
                                        fontSize: "18px",
                                        color: "#C4554D",
                                        // backgroundColor: "#FAECEC",
                                      }}
                                    > Reupload Document</i>
                                  </span> */}
                                    </div>
                                  )}
                                </>
                              )}
                            </div>
                            {!uploadedFile && (
                              <div className="d-flex align-items-center">
                                <input
                                  type="file"
                                  className="form-control me-2"
                                  onChange={(e) => {
                                    handleFileChange(e);
                                  }}
                                />
                                {/* <button
                            type="button"
                            className="btn btn-danger"
                            onClick={() => handleRemove(index)}
                            disabled={files.length === 1}
                          >
                            Remove
                          </button> */}
                                {/* <span title="Delete"
                                onClick={() => handleRemove(index)}
                                disabled={files.length === 1}
                              >
                                <i
                                  className="fa-regular fa-trash-can"
                                  style={{
                                    cursor: "pointer",
                                    marginRight: "10px",
                                    padding: "5px",
                                    fontSize: "1.5em",
                                    color: "#C4554D",
                                    backgroundColor: "#FAECEC",
                                  }}
                                ></i>
                              </span> */}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>

                {/* <div class="col-12 ">

                  <button
                    type="submit"
                    onClick={(e) => handleDocumentUpload(e)}
                    class="btn btn-primaryb mt-3 addBlogBtn"
                    style={{
                      background: "linear-gradient(195deg, #FFB14C, #ff9000)",
                      color: "#fff",
                    }}
                  >
                    Upload
                  </button>
                </div> */}
              </form>
            </section>
          </div>
        </div>
      )}

      <div className="d-flex justify-content-end">
        <div className="form-header">
          <section className="piechartsBox_area">
            <div>
              <div className="dateListDiv">
                <h1
                  style={{
                    color: "#ff9c00",
                    fontSize: "25px",
                    fontWeight: "600",
                    marginBottom: "10px",
                  }}
                >
                  Services assigned to {user?.userData?.email}
                </h1>
              </div>
            </div>

            <hr />
            <DataTable columns={columns} data={allData} pagination />
          </section>
        </div>
      </div>
    </>
  );
};

export default AssignedServices;
